module.exports = __webpack_public_path__ + "img/Multiview - Green - Selected.06b15780.png";